<template>
  <div>
    <div class="">
      <!-- Middle Navigation (Desktop)-->
      <div class="hidden-sm-and-down">
        <v-app-bar >
          <router-link to="/" class="navbar-item">
            <img src="@/assets/logo.png" alt="Convergeo" /> 
          </router-link>
          <v-spacer></v-spacer>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-text-field v-model="searchAll" label="Quick Search" append-icon="mdi-magnify" single-line hide-details v-on=
              "on"></v-text-field>
            </template>
            <v-list v-if="(searchAll !== '') && (searchAll.length >= 3)"   dense>
              <v-list-item v-for="(client, i) in filteredClientAll" :key="i">
                  <router-link :to="/client/+ client.slug"  v-if="client">
                    <v-layout>
                      <v-flex x3>
                        <v-list-item-content>
                          <v-avatar color="indigo" size="22">
                            <span class="white--text">Cl</span>
                          </v-avatar>
                        </v-list-item-content>
                      </v-flex>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-flex x9>
                        <v-list-item-content>
                          <span
                            class="text-captalise font-weight-bold caption"
                            v-text="client.displayName"
                          ></span>
                        </v-list-item-content>
                      </v-flex>
                    </v-layout>
                  </router-link>
              </v-list-item>
              <v-list-item v-for="(category, i) in filteredCatAll" :key="i">
                <div v-if="category.type == 'product'">
                  <router-link :to="/products/ + category.slug">
                    <v-layout>
                      <v-flex x3>
                        <v-list-item-content>
                          <v-avatar color="red lighten-1" size="22">
                            <span class="white--text">Pr</span>
                          </v-avatar>
                        </v-list-item-content>
                      </v-flex>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-flex x9>
                        <v-list-item-content>
                          <span
                            class="text-captalise font-weight-bold caption"
                            v-text="category.name"
                          ></span>
                        </v-list-item-content>
                      </v-flex>
                    </v-layout>
                  </router-link>
                </div>
                <div v-if="category.type == 'service'">
                  <router-link :to="/services/ + category.slug">
                    <v-layout>
                      <v-flex x3>
                        <v-list-item-content>
                          <v-avatar color="blue lighten-1" size="22">
                            <span class="white--text">Se</span>
                          </v-avatar>
                        </v-list-item-content>
                      </v-flex>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-flex x9>
                        <v-list-item-content>
                          <span
                            class="text-captalise font-weight-bold caption"
                            v-text="category.name"
                          ></span>
                        </v-list-item-content>
                      </v-flex>
                    </v-layout>
                  </router-link>
                </div>
                <div v-if="category.type == 'event'">
                  <router-link :to="/events/ + category.slug">
                    <v-layout>
                      <v-flex x3>
                        <v-list-item-content>
                          <v-avatar color="green lighten-2" size="22">
                            <span class="white--text">Ev</span>
                          </v-avatar>
                        </v-list-item-content>
                      </v-flex>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-flex x9>
                        <v-list-item-content>
                          <span
                            class="text-captalise font-weight-bold caption"
                            v-text="category.name"
                          ></span>
                        </v-list-item-content>
                      </v-flex>
                    </v-layout>
                  </router-link>
                </div>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-toolbar-title v-if="!userIsAuthenticated">
            <router-link to="/signin" class="click navbar-item">
              <v-icon>mdi-lock-open mdi-24px</v-icon>
              {{ $t('navigation_signin') }}
            </router-link>
          </v-toolbar-title>
          <v-toolbar-title v-if="!userIsAuthenticated">
            <router-link to="/signup" class="click navbar-item">
              <v-icon>mdi-face mdi-24px</v-icon>
              {{ $t('navigation_signup') }}
            </router-link>
          </v-toolbar-title>
          <v-toolbar-title v-if="userIsAuthenticated">
            <router-link to="/cart" class="click navbar-item">
              <v-icon>mdi-cart mdi-24px</v-icon>
              {{ $t('navigation_cart') }}
              <span style="padding-bottom: 15px;" v-if="cartitems.length">
                <v-avatar color="indigo" size="17">
                  <span class="white--text" style="font-size: 16px">
                    {{cartitems.length}}
                  </span>
                </v-avatar>
              </span>
            </router-link>
          </v-toolbar-title>
          <v-toolbar-title v-if="userIsAuthenticated">
            <router-link to="/orders" class="click navbar-item">
              <v-icon>mdi-credit-card-clock mdi-24px</v-icon>
              {{ $t('navigation_orders') }}
            </router-link>
          </v-toolbar-title>
          <v-toolbar-title>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
          </v-toolbar-title>
        </v-app-bar>
      </div>
      <!-- Middle Navigation (Mobile)-->
      <div class="hidden-md-and-up">
        <v-app-bar color="deep-purple accent-4" dark>
          <b v-if="$route.name !== 'home'"  @click="back"><v-btn rounded color="deep-purple accent-2" fab small><v-icon>mdi-arrow-left</v-icon></v-btn></b>
          <b v-else>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
          </b>
          <v-spacer></v-spacer>
          <mobileName v-if="searcher"/>
          <v-menu offset-y v-else>
            <template v-slot:activator="{ on }">
              <v-text-field v-model="searchAll" label="Quick Search" single-line hide-details v-on=
              "on"></v-text-field>
            </template>
            <v-list v-if="(searchAll !== '') && (searchAll.length >= 3)"   dense>
              <v-list-item v-for="(client, i) in filteredClientAll" :key="i">
                  <router-link :to="/client/+ client.slug"  v-if="client">
                    <v-layout>
                      <v-flex x3>
                        <v-list-item-content>
                          <v-avatar color="indigo" size="22">
                            <span class="white--text">Cl</span>
                          </v-avatar>
                        </v-list-item-content>
                      </v-flex>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-flex x9>
                        <v-list-item-content>
                          <span
                            class="text-captalise font-weight-bold caption"
                            v-text="client.displayName"
                          ></span>
                        </v-list-item-content>
                      </v-flex>
                    </v-layout>
                  </router-link>
              </v-list-item>
              <v-list-item v-for="(category, i) in filteredCatAll" :key="i">
                <div v-if="category.type == 'product'">
                  <router-link :to="/products/ + category.slug">
                    <v-layout>
                      <v-flex x3>
                        <v-list-item-content>
                          <v-avatar color="red lighten-1" size="22">
                            <span class="white--text">Pr</span>
                          </v-avatar>
                        </v-list-item-content>
                      </v-flex>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-flex x9>
                        <v-list-item-content>
                          <span
                            class="text-captalise font-weight-bold caption"
                            v-text="category.name"
                          ></span>
                        </v-list-item-content>
                      </v-flex>
                    </v-layout>
                  </router-link>
                </div>
                <div v-if="category.type == 'service'">
                  <router-link :to="/services/ + category.slug">
                    <v-layout>
                      <v-flex x3>
                        <v-list-item-content>
                          <v-avatar color="blue lighten-1" size="22">
                            <span class="white--text">Se</span>
                          </v-avatar>
                        </v-list-item-content>
                      </v-flex>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-flex x9>
                        <v-list-item-content>
                          <span
                            class="text-captalise font-weight-bold caption"
                            v-text="category.name"
                          ></span>
                        </v-list-item-content>
                      </v-flex>
                    </v-layout>
                  </router-link>
                </div>
                <div v-if="category.type == 'event'">
                  <router-link :to="/events/ + category.slug">
                    <v-layout>
                      <v-flex x3>
                        <v-list-item-content>
                          <v-avatar color="green lighten-2" size="22">
                            <span class="white--text">Ev</span>
                          </v-avatar>
                        </v-list-item-content>
                      </v-flex>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-flex x9>
                        <v-list-item-content>
                          <span
                            class="text-captalise font-weight-bold caption"
                            v-text="category.name"
                          ></span>
                        </v-list-item-content>
                      </v-flex>
                    </v-layout>
                  </router-link>
                </div>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-spacer></v-spacer>
          <b v-if="$route.name != 'home'">
            <v-icon @click="open_search" v-if="searcher">mdi-magnify</v-icon>
              <v-icon @click="close_search" v-else>mdi-magnify</v-icon>
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
          </b>
          <b v-else>
            <v-btn icon>
              <v-icon @click="open_search" v-if="searcher">mdi-magnify</v-icon>
              <v-icon @click="close_search" v-else>mdi-magnify</v-icon>
            </v-btn>
          </b>
        </v-app-bar>
      </div>
    </div>
    <div>
      <v-navigation-drawer v-model="drawer" absolute>
        <v-list-item  v-if="userIsAuthenticated">
          <v-list-item-avatar size="50" v-if="user">
            <v-img :src="getMyImage(user.user_image)" alt="User"></v-img>
          </v-list-item-avatar>
          <v-spacer></v-spacer>
          <v-btn rounded color="indigo" small text dark @click="signouthome()"  v-if="$route.name !== 'home'">
          {{ $t('navigation_logout') }}</v-btn>
          <v-btn rounded color="indigo" small text dark @click="signout()" v-else>
          {{ $t('navigation_logout') }}</v-btn>
          <v-btn rounded color="black" text small dark @click.stop="settings_drawer = !settings_drawer">
            <v-icon>mdi-settings</v-icon>
          </v-btn>
        </v-list-item>
        <v-list-item class="hidden-md-and-up">
          <v-list-item-title>
              <select v-model="$i18n.locale">
                <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">{{ lang }}</option>
              </select>
              <v-icon style="color: black;">mdi-chevron-down</v-icon>
            <span><b>{{$t('navigation_language')}}</b></span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="userIsAuthenticated">
          <v-list-item-title v-if="user">
            <b>{{user.name}}</b>
            <br>{{user.email}}
          </v-list-item-title>
        </v-list-item>
        <v-list-item  v-if="!userIsAuthenticated">
          <v-list-item-avatar>
            <v-img src="@/assets/icon.png" contain></v-img>
          </v-list-item-avatar>
          <v-spacer></v-spacer>
          <v-btn rounded color="black" text small dark @click.stop="settings_drawer = !settings_drawer">
            <v-icon>mdi-settings</v-icon>
          </v-btn>
        </v-list-item>
        <v-list-item v-if="!userIsAuthenticated">
          <v-list-item-title class="label">{{ $t('welcome_title')}} Convergeo</v-list-item-title>
        </v-list-item>
        <template>
          <div class="text-center" v-if="isOnline">
            <v-btn x-small rounded dark text color="green darken-1">
              <v-icon>mdi-account</v-icon> <b>{{$t('common_online')}}</b>
            </v-btn>
          </div>
          <div class="text-center" v-if="isOffline">
            <v-btn x-small rounded dark text color="red darken-2">
              <v-icon>mdi-account</v-icon> <b>{{$t('common_offline')}}</b>
            </v-btn>
          </div>
        </template>
        <v-divider></v-divider>
        <div>
          <v-tabs>
            <v-tab><v-icon>mdi-home</v-icon></v-tab><!-- Home -->
            <v-tab><v-icon>mdi-account</v-icon></v-tab><!-- User -->
            <v-tab-item>
                <!-- Product Drawer -->
                <v-list-item link>
                  <v-list-item-icon>
                    <v-icon>mdi-gift</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title><b  @click.stop="product_drawer = !product_drawer"
                      >{{$t('common_product')}}</b></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!-- Product Drawer: End -->

                <v-list-item link>
                  <v-list-item-icon>
                    <v-icon>mdi-doctor</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title><b  @click.stop="service_drawer = !service_drawer"
                      >{{$t('common_service')}}</b></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-icon>
                    <v-icon>mdi-calendar-month</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title><b  @click.stop="event_drawer = !event_drawer"
                      >{{$t('common_event')}}</b></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-icon>
                    <v-icon>mdi-animation</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title><b  @click.stop="client_drawer = !client_drawer"
                      >{{$t('common_client')}}</b></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
            </v-tab-item>
            <v-tab-item>
              <b dense v-if="userIsAuthenticated">
                <v-list-item link>
                  <v-list-item-icon>
                    <v-icon>mdi-view-dashboard</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title><router-link to="/dashboard/home" class="click">{{ $t('navigation_dashboard') }}</router-link></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-icon>
                    <v-icon>mdi-credit-card-clock</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title><router-link to="/orders" class="click">{{ $t('navigation_orders') }}</router-link></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-icon>
                    <v-icon>mdi-cart</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-if="cartitems.length">
                      <router-link to="/cart" class="click">
                        {{ $t('navigation_cart') }}
                        ({{cartitems.length}})
                      </router-link>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-icon>
                    <v-icon>mdi-xbox-controller</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title><router-link to="/wishlist" class="click">{{ $t('navigation_wishlist') }}</router-link></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-icon>
                    <v-icon>mdi-bell-ring</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title><router-link to="/dashboard/notifications" class="click">{{ $t('navigation_notifications') }}</router-link></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </b>
              <b dense v-if="!userIsAuthenticated">
                <v-list-item link>
                  <v-list-item-icon>
                    <v-icon>mdi-lock-open</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title><router-link to="/signin" class="click">{{ $t('navigation_signin') }}</router-link></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item link>
                  <v-list-item-icon>
                    <v-icon>mdi-face</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title><router-link to="/signup" class="click">{{ $t('navigation_signup') }}</router-link></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </b>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-navigation-drawer>
    </div>
    <!-- // Product Drawer -->
    <div>
      <v-navigation-drawer v-model="product_drawer" absolute temporary>
        <v-toolbar-title>
          <div class="navbar-item">
            <v-icon>mdi-gift mdi-24px</v-icon>{{ $t('common_product') }}
            <v-spacer></v-spacer>
            <v-icon @click.stop="product_drawer = !product_drawer">mdi-close mdi-24px</v-icon>
          </div>
        </v-toolbar-title>
          <span>
            <span v-for="category in categories" :key="category.id" >
              <v-list-group v-if="(category.type == 'product') && (category.title_tag == 'Electronics')">
                <template v-slot:activator>
                  <v-list-item-content>
                    <span class="label">Electronics</span>
                  </v-list-item-content>
                </template>
                <v-list-item>
                  <router-link :to="{ name: 'alt_products', params: { slug: category.slug } }" v-if="$route.name !== 'alt_products'">
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                  <router-link :to="{ name: 'products', params: { slug: category.slug } }"  v-else>
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                </v-list-item>
              </v-list-group>
            </span>
          </span>
          <span>
            <span v-for="category in categories" :key="category.id" >
              <v-list-group v-if="(category.type == 'product') && (category.title_tag == 'Fashion Store')">
                <template v-slot:activator>
                  <v-list-item-content>
                    <span class="label">Fashion Store</span>
                  </v-list-item-content>
                </template>
                <v-list-item>
                  <router-link :to="{ name: 'alt_products', params: { slug: category.slug } }" v-if="$route.name !== 'alt_products'">
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                  <router-link :to="{ name: 'products', params: { slug: category.slug } }"  v-else>
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                </v-list-item>
              </v-list-group>
            </span>
          </span>
          <span>
            <span v-for="category in categories" :key="category.id" >
              <v-list-group v-if="(category.type == 'product') && (category.title_tag == 'Kids & Toys')">
                <template v-slot:activator>
                  <v-list-item-content>
                    <span class="label">Kids & Toys</span>
                  </v-list-item-content>
                </template>
                <v-list-item>
                  <router-link :to="{ name: 'alt_products', params: { slug: category.slug } }" v-if="$route.name !== 'alt_products'">
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                  <router-link :to="{ name: 'products', params: { slug: category.slug } }"  v-else>
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                </v-list-item>
              </v-list-group>
            </span>
          </span>
          <span>
            <span v-for="category in categories" :key="category.id" >
              <v-list-group v-if="(category.type == 'product') && (category.title_tag == 'Home, Furniture & Patio')">
                <template v-slot:activator>
                  <v-list-item-content>
                    <span class="label">Home, Furniture & Patio</span>
                  </v-list-item-content>
                </template>
                <v-list-item>
                  <router-link :to="{ name: 'alt_products', params: { slug: category.slug } }" v-if="$route.name !== 'alt_products'">
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                  <router-link :to="{ name: 'products', params: { slug: category.slug } }"  v-else>
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                </v-list-item>
              </v-list-group>
            </span>
          </span>
          <span>
            <span v-for="category in categories" :key="category.id" >
              <v-list-group v-if="(category.type == 'product') && (category.title_tag == 'Sports, Fitness & Outdoor')">
                <template v-slot:activator>
                  <v-list-item-content>
                    <span class="label">Sports, Fitness & Outdoor</span>
                  </v-list-item-content>
                </template>
                <v-list-item>
                  <router-link :to="{ name: 'alt_products', params: { slug: category.slug } }" v-if="$route.name !== 'alt_products'">
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                  <router-link :to="{ name: 'products', params: { slug: category.slug } }"  v-else>
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                </v-list-item>
              </v-list-group>
            </span>
          </span>
          <span> 
            <span v-for="category in categories" :key="category.id" >
              <v-list-group v-if="(category.type == 'product') && (category.title_tag == 'Grocery Store')">
                <template v-slot:activator>
                  <v-list-item-content>
                    <span class="label">Grocery Store</span>
                  </v-list-item-content>
                </template>
                <v-list-item>
                  <router-link :to="{ name: 'alt_products', params: { slug: category.slug } }" v-if="$route.name !== 'alt_products'">
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                  <router-link :to="{ name: 'products', params: { slug: category.slug } }"  v-else>
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                </v-list-item>
              </v-list-group>
            </span>
          </span>
          <span>
            <span v-for="category in categories" :key="category.id" >
              <v-list-group v-if="(category.type == 'product') && (category.title_tag == 'Photos, Gifts and Office Supplies')">
                <template v-slot:activator>
                  <v-list-item-content>
                    <span class="label">Photos, Gifts and Office Supplies</span>
                  </v-list-item-content>
                </template>
                <v-list-item>
                  <router-link :to="{ name: 'alt_products', params: { slug: category.slug } }" v-if="$route.name !== 'alt_products'">
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                  <router-link :to="{ name: 'products', params: { slug: category.slug } }"  v-else>
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                </v-list-item>
              </v-list-group>
            </span>
          </span>
          <span>
            <span v-for="category in categories" :key="category.id" >
              <v-list-group v-if="(category.type == 'product') && (category.title_tag == 'Health, Beauty and Pharmacy')">
                <template v-slot:activator>
                  <v-list-item-content>
                    <span class="label">Health, Beauty and Pharmacy</span>
                  </v-list-item-content>
                </template>
                <v-list-item>
                  <router-link :to="{ name: 'alt_products', params: { slug: category.slug } }" v-if="$route.name !== 'alt_products'">
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                  <router-link :to="{ name: 'products', params: { slug: category.slug } }"  v-else>
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                </v-list-item>
              </v-list-group>
            </span>
          </span>
          <span>
            <span v-for="category in categories" :key="category.id" >
              <v-list-group v-if="(category.type == 'product') && (category.title_tag == 'Health, Beauty and Pharmacy')">
                <template v-slot:activator>
                  <v-list-item-content>
                    <span class="label">Health, Beauty and Pharmacy</span>
                  </v-list-item-content>
                </template>
                <v-list-item>
                  <router-link :to="{ name: 'alt_products', params: { slug: category.slug } }" v-if="$route.name !== 'alt_products'">
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                  <router-link :to="{ name: 'products', params: { slug: category.slug } }"  v-else>
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                </v-list-item>
              </v-list-group>
            </span>
          </span>
          <span>
            <span v-for="category in categories" :key="category.id" >
              <v-list-group v-if="(category.type == 'product') && (category.title_tag == 'Automation')">
                <template v-slot:activator>
                  <v-list-item-content>
                    <span class="label">Automation</span>
                  </v-list-item-content>
                </template>
                <v-list-item>
                  <router-link :to="{ name: 'alt_products', params: { slug: category.slug } }" v-if="$route.name !== 'alt_products'">
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                  <router-link :to="{ name: 'products', params: { slug: category.slug } }"  v-else>
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                </v-list-item>
              </v-list-group>
            </span>
          </span>
          <span>
            <span v-for="category in categories" :key="category.id" >
              <v-list-group v-if="(category.type == 'product') && (category.title_tag == 'Books, Music and Movies')">
                <template v-slot:activator>
                  <v-list-item-content>
                    <span class="label">Books, Music and Movies</span>
                  </v-list-item-content>
                </template>
                <v-list-item>
                  <router-link :to="{ name: 'alt_products', params: { slug: category.slug } }" v-if="$route.name !== 'alt_products'">
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                  <router-link :to="{ name: 'products', params: { slug: category.slug } }"  v-else>
                    <v-list-item-content dense link>
                      <b class="font-weight-bold click" style="font-size: 15px;">{{ category.name }}</b>
                    </v-list-item-content>
                  </router-link>
                </v-list-item>
              </v-list-group>
            </span>
          </span>
      </v-navigation-drawer>
    </div>
    <!-- // Service Drawer -->
    <div>
      <v-navigation-drawer v-model="service_drawer" absolute temporary>
          <v-toolbar-title>
            <div class="navbar-item">
              <v-icon>mdi-doctor mdi-24px</v-icon>{{ $t('common_service') }}
              <v-spacer></v-spacer>
              <v-icon @click.stop="service_drawer = !service_drawer">mdi-close mdi-24px</v-icon>
            </div>
          </v-toolbar-title>
          <v-divider></v-divider>
          <div v-for="category in categories" :key="category.id" >
            <div v-if="category.type =='service'">
              <v-list-item dense>
                <router-link :to="{ name: 'alt_services', params: { slug: category.slug } }" class="click" v-if="$route.name !== 'alt_services'"><v-list-item-content link>
                  <div class="label">{{ category.name }}</div>
                </v-list-item-content></router-link>
                <router-link :to="{ name: 'services', params: { slug: category.slug } }" class="click" v-else><v-list-item-content link>
                  <div class="label">{{ category.name }}</div>
                </v-list-item-content></router-link>
              </v-list-item>
            </div>
          </div>
      </v-navigation-drawer>
    </div>
    <!-- // Event Drawer -->
    <div>
      <v-navigation-drawer v-model="event_drawer" absolute temporary>
          <v-toolbar-title>
            <div class="navbar-item">
              <v-icon>mdi-calendar-month mdi-24px</v-icon>{{ $t('common_event') }}
              <v-spacer></v-spacer>
              <v-icon @click.stop="event_drawer = !event_drawer">mdi-close mdi-24px</v-icon>
            </div>
          </v-toolbar-title>
          <v-divider></v-divider>
          <div v-for="category in categories" :key="category.id" >
            <div v-if="category.type =='event'">
              <v-list-item dense link>
                <router-link :to="{ name: 'alt_events', params: { slug: category.slug } }"  class="click" v-if="$route.name !== 'alt_events'"><v-list-item-content>
                  <div class="label">{{ category.name }}</div>
                </v-list-item-content></router-link>
                <router-link :to="{ name: 'events', params: { slug: category.slug } }"  class="click" v-else><v-list-item-content>
                  <div class="label">{{ category.name }}</div>
                </v-list-item-content></router-link>
              </v-list-item>
            </div>
          </div>
      </v-navigation-drawer>
    </div>
    <!-- // Client Drawer -->
    <div>
      <v-navigation-drawer v-model="client_drawer" absolute temporary>
          <v-toolbar-title>
            <div class="navbar-item">
              <v-icon>mdi-animation mdi-24px</v-icon>{{ $t('common_client') }}
              <v-spacer></v-spacer>
              <v-icon @click.stop="client_drawer = !client_drawer">mdi-close mdi-24px</v-icon>
            </div>
          </v-toolbar-title>
          <v-divider></v-divider>
          <div class="container">
            <v-text-field v-model="searchClients" append-icon="mdi-magnify" :label="$t('client_search')" single-line hide-details></v-text-field>
            <!-- Also add category tags for products above -->
            <v-list three-line dense v-if="searchClients !== ''">
              <v-list-item v-for="(client, i) in filteredClients" :key="i" ripple @click="() => {}" dense><!-- Link to Client Page -->
                <router-link :to="'client/'+ client.slug">
                  <img :src="getImage(client.logos)" alt="Logo" class="mr-4" width="74">
                  <v-list-item-content>
                    <span
                      class="text-uppercase font-weight-regular caption"
                      v-text="client.displayName"
                    ></span>
                  </v-list-item-content>
                </router-link>
              </v-list-item>
            </v-list>
          </div>
      </v-navigation-drawer>
    </div>
    <!-- // Setting Drawer -->
    <div>
      <v-navigation-drawer v-model="settings_drawer" absolute temporary>
          <v-toolbar-title>
            <div class="navbar-item">
              <v-icon>mdi-settings mdi-24px</v-icon>{{$t('common_documents')}}
              <v-spacer></v-spacer>
              <v-icon @click.stop="settings_drawer = !settings_drawer">mdi-close mdi-24px</v-icon>
            </div>
          </v-toolbar-title>
          <v-divider></v-divider>
          <b>
            <v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-account-card-details</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title><router-link to="/documents/about-us" class="click">{{ $t('document_about_us') }}</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-stack-exchange</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title><router-link to="/documents/terms-and-conditions" class="click">{{ $t('document_terms_condition') }}</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-incognito</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title><router-link to="/documents/disclaimer" class="click">{{ $t('document_disclaimer') }}</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-sword-cross</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title><router-link to="/documents/terms-of-service" class="click">{{ $t('document_terms_service') }}</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-security</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title><router-link to="/documents/privacy-policy" class="click">{{ $t('document_privacy') }}</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-decagram-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title><router-link to="/documents/cookies" class="click">{{ $t('document_cookies') }}</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-update</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title><router-link to="/documents/return-and-refund-policy" class="click">{{ $t('document_refunds') }}</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link>
              <v-list-item-icon>
                <v-icon>mdi-account-question</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title><router-link to="/documents/end-user-license-agreement" class="click">EULA</router-link></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </b>
      </v-navigation-drawer>
    </div>   
  </div>
</template>

<script>
  import {fb,db,auth} from '@/firebase'
  import mobileName from './mobilename'

  export default {
    name: 'midnav',
    data () {
      return {
        langs: ['en','nj','fr','ru','ch'] ,
        searcher: true,
        cartitems: [],
        user: null,
        userauth: null,
        searchAll:'',
        searchClients: '',
        clients:[],
        categories: [],
        drawer: null,
        product_drawer: null,
        service_drawer: null,
        event_drawer: null,
        settings_drawer: null,
        client_drawer: null
      }
    },

    components: {
      mobileName
    },

    computed: {
      userIsAuthenticated () {
        return this.userauth != null && this.userauth != undefined
      },
      filteredClients(){
        if (this.searchClients) {
          const regexp = new RegExp(this.searchClients, 'gi');
          return this.clients.filter(client =>
            (client.displayName + client.slug).match(regexp));
        }
        return this.clients;
      },
      filteredClientAll(){
        if (this.searchAll) {
          const regexp = new RegExp(this.searchAll, 'gi');
          return this.clients.filter(client =>
            (client.displayName + client.slug).match(regexp));
        }
        return this.clients;
      },
      filteredCatAll(){
        if (this.searchAll) {
          const regexp = new RegExp(this.searchAll, 'gi');
          return this.categories.filter(category =>
            (category.displayName + category.slug).match(regexp));
        }
        return this.categories;
      }
    },

    methods: {
      back(){
        this.$router.go(-1)
      },
      open_search(){
        this.searcher = false
      },
      close_search(){
        this.searcher = true
      },
      getImage(logos){
        return logos[0]
      },
      getMyImage(user_image){
        return user_image[0]
      },
      signout() {
        auth.signOut()
        .then(() => {
          this.$router.replace('/')
        })
        .catch((err) => {
          /* eslint-disable no-console */
          console.log(err);
          /* eslint-enable no-console */
        })
      },
      signouthome() {
        auth.signOut()
        .then(() => {
          this.$router.replace('/signin')
        })
        .catch((err) => {
          /* eslint-disable no-console */
          console.log(err);
          /* eslint-enable no-console */
        })
      }
    },

    firestore:{
      categories: 
      db.collection('categories')
      .where('status','==',1),
      clients: 
      db.collection('clients')
      .where('status','==',1)
    },
    
    created () {
      auth.onAuthStateChanged(userauth => {
        if(userauth){
          this.userauth = userauth;
        } else {
          this.userauth = null;
        }
      })
      db.collection('user').where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user = doc.data()
          this.user.id = doc.id
        })
      })
      db.collection('cartitems').where('user','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.cartitems = doc.data()
          this.cartitems.id = doc.id
        })
      })
    }  
  };
</script>

<style scoped>
  .click {
    color: grey
  }
  .click:hover {
    color: blue
  }
</style>

